<ng-container *ngrxLet="vm$$; let vm">
    <div *ngIf="isLoggedIn" class="header header-logged-in">
        <div class="h-100 d-flex flex-wrap justify-content-center position-relative">
            <ca-workflow-panel data-uit="workflow-panel" *ngIf="isLoggedIn" [hidden]="!vm.hasActiveWorkflow$"></ca-workflow-panel>
            <div class="col-10 ps-0 d-flex align-items-center header-content-wrapper">
                <button
                    *ngIf="vm.isSmallDevice$"
                    type="button"
                    class="btn ca-btn-icon ca-btn-icon-big menu-icon me-3"
                    (click)="_toggleSidebar(true)"
                    [title]="'GENERAL.OPEN_MENU' | translate"
                >
                    <ca-icon name="menu" size="l"></ca-icon>
                </button>
                <div class="w-100 header-content" data-uit="header-content">
                    <div class="d-flex breadcrumb-container align-items-center justify-content-between">
                        <div class="d-flex align-items-center">
                            <ca-breadcrumb class="ps-0" *ngIf="isLoggedIn" [breadcrumbParts]="vm.breadcrumbParts$"></ca-breadcrumb>
                            <div *ngIf="vm.hasDescriptionText$">
                                <button type="button" class="btn ca-btn-icon ms-2" (click)="toggleExpanded()">
                                    <ca-icon *ngIf="!vm.isExpanded$" name="question-mark" size="s"></ca-icon>
                                    <ca-icon *ngIf="vm.isExpanded$" name="minus" size="s"></ca-icon>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <ca-notifications-alarm class="notifications-alarm">
                <ca-notifications-list></ca-notifications-list>
            </ca-notifications-alarm>
        </div>
    </div>
    <div *ngIf="!isLoggedIn" class="header header-logged-out">
        <header *ngIf="vm.isSmallDevice$" class="logged-out-header d-flex align-items-center px-5">
            <button type="button" class="btn ca-btn-icon ca-btn-icon-big menu-icon" (click)="_toggleSidebar(true)" [title]="'GENERAL.OPEN_MENU' | translate">
                <ca-icon name="menu" size="l"></ca-icon>
            </button>
            <h1>
                <div class="logo-container d-flex align-items-center">
                    <a [routerLink]="landingPageUrl" title="arivis Cloud" class="logo logo-big ms-2 mb-2">
                        <img *ngIf="isMEDProjectEnabled" [src]="logoPath" alt="arivis Cloud Logo" class="img-fluid MED-logo-large" />
                        <span *ngIf="!isMEDProjectEnabled" [inlineSVG]="logoPath" [cacheSVG]="true"></span>
                    </a>
                </div>
            </h1>
        </header>
        <section *ngIf="!vm.isSmallDevice$" class="logged-out-header d-flex align-items-center justify-content-between">
            <div class="row justify-content-center w-100">
                <div class="col-10">
                    <div class="row justify-content-between align-items-center">
                        <div class="logo-container col-3 logo-wrapper d-flex align-items-center">
                            <a [routerLink]="landingPageUrl" title="arivis Cloud" class="logo logo-big ms-2">
                                <img *ngIf="isMEDProjectEnabled" [src]="logoPath" alt="arivis Cloud Logo" class="img-fluid MED-logo-large" />
                                <span *ngIf="!isMEDProjectEnabled" [inlineSVG]="logoPath" [cacheSVG]="true"></span>
                            </a>
                        </div>
                        <div class="col-6 pe-0 h-100 d-flex align-items-center justify-content-end">
                            <a *ngIf="!isMEDProjectEnabled" href="https://www.apeer.com/free-trial" skipLocationChange class="signup-btn font-sm">{{
                                'GENERAL.START_FREE_TRIAL' | translate
                            }}</a>
                            <a [routerLink]="['implicit-login']" skipLocationChange class="login-btn font-sm">{{ 'GENERAL.LOGIN' | translate }}</a>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</ng-container>
